(() => {
  const mount = (root) => {
  if (!root || root.dataset.indexInitialized === 'true') return;

  const index = root.querySelector('[data-fw26-index]');
  if (!index) return;
  root.dataset.indexInitialized = 'true';

  const desktopQuery = window.matchMedia('(min-width: 700px)');
  const storageKey = `fw26-index:${location.pathname}`;
  const cards = [...index.querySelectorAll('[data-fabric-card]')];
  const garmentButtons = [...index.querySelectorAll('[data-garment]')];
  const fitButtons = [...index.querySelectorAll('[data-fit]')];
  const minimumInput = index.querySelector('[data-weight-min]');
  const maximumInput = index.querySelector('[data-weight-max]');
  const range = index.querySelector('[data-weight-range]');
  const output = index.querySelector('[data-weight-output]');
  const reset = index.querySelector('[data-index-reset]');
  const status = index.querySelector('[data-index-status]');

  if (!minimumInput || !maximumInput || !range) return;

  const absoluteMinimum = Number(minimumInput.min);
  const absoluteMaximum = Number(maximumInput.max);
  const minimumGap = Number(minimumInput.step) || 0.25;
  const defaultState = {
    garment: 'all',
    fits: [],
    minimum: absoluteMinimum,
    maximum: absoluteMaximum
  };

  const readStorage = () => {
    try {
      return JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    } catch (_) {
      return {};
    }
  };

  const cloneState = (state) => ({
    garment: state?.garment || 'all',
    fits: Array.isArray(state?.fits) ? [...state.fits] : [],
    minimum: Number.isFinite(Number(state?.minimum)) ? Number(state.minimum) : absoluteMinimum,
    maximum: Number.isFinite(Number(state?.maximum)) ? Number(state.maximum) : absoluteMaximum
  });

  let state = cloneState({ ...defaultState, ...(readStorage().filters || {}) });

  const writeStorage = () => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        ...readStorage(),
        filters: state
      }));
    } catch (_) {}
  };

  const formatWeight = (value) => {
    const number = Number(value);
    return `${Number.isInteger(number) ? number : Number(number.toFixed(2))}oz`;
  };

  const weightFiltered = () =>
    state.minimum > absoluteMinimum || state.maximum < absoluteMaximum;

  const cardMatches = (card) => {
    const garments = (card.dataset.garments || '').split(/\s+/).filter(Boolean);
    const fits = (card.dataset.fits || '').split(/\s+/).filter(Boolean);
    const weight = Number(card.dataset.weight);
    const garmentMatch = state.garment === 'all' || garments.includes(state.garment);
    const fitMatch = state.fits.every((fit) => fits.includes(fit));
    const weightMatch = !weightFiltered() ||
      (Number.isFinite(weight) && weight >= state.minimum && weight <= state.maximum);
    return garmentMatch && fitMatch && weightMatch;
  };

  const updateIndex = ({ announce = true } = {}) => {
    let visibleCount = 0;

    cards.forEach((card) => {
      const visible = cardMatches(card);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    garmentButtons.forEach((button) => {
      const active = button.dataset.garment === state.garment;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    fitButtons.forEach((button) => {
      const active = state.fits.includes(button.dataset.fit);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    minimumInput.value = String(state.minimum);
    maximumInput.value = String(state.maximum);

    const startPercent = ((state.minimum - absoluteMinimum) / (absoluteMaximum - absoluteMinimum)) * 100;
    const endPercent = ((state.maximum - absoluteMinimum) / (absoluteMaximum - absoluteMinimum)) * 100;
    range.style.setProperty('--range-start', `${startPercent}%`);
    range.style.setProperty('--range-end', `${endPercent}%`);

    if (output) {
      output.textContent = weightFiltered()
        ? `${formatWeight(state.minimum)} – ${formatWeight(state.maximum)}`
        : root.dataset.allWeightsLabel;
    }

    if (status) {
      const label = visibleCount === 1 ? 'fabric' : root.dataset.resultsLabel;
      status.textContent = `${visibleCount} ${label}`;
    }

    writeStorage();
    if (announce) {
      root.dispatchEvent(new CustomEvent('fw26:filters-state', {
        detail: cloneState(state)
      }));
    }
  };

  garmentButtons.forEach((button) => {
    button.addEventListener('click', () => {
      state.garment = button.dataset.garment;
      updateIndex();
    });
  });

  fitButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const fit = button.dataset.fit;
      state.fits = state.fits.includes(fit)
        ? state.fits.filter((item) => item !== fit)
        : [...state.fits, fit];
      updateIndex();
    });
  });

  const updateWeight = (changed) => {
    if (Number(minimumInput.value) > Number(maximumInput.value) - minimumGap) {
      if (changed === 'minimum') {
        minimumInput.value = String(Number(maximumInput.value) - minimumGap);
      } else {
        maximumInput.value = String(Number(minimumInput.value) + minimumGap);
      }
    }
    state.minimum = Number(minimumInput.value);
    state.maximum = Number(maximumInput.value);
    updateIndex();
  };

  minimumInput.addEventListener('input', () => updateWeight('minimum'));
  maximumInput.addEventListener('input', () => updateWeight('maximum'));

  reset?.addEventListener('click', () => {
    state = cloneState(defaultState);
    updateIndex();
  });

  root.addEventListener('fw26:external-filters', (event) => {
    state = cloneState(event.detail || defaultState);
    if (desktopQuery.matches) updateIndex();
    else writeStorage();
  });

  desktopQuery.addEventListener?.('change', (event) => {
    state = cloneState({ ...defaultState, ...(readStorage().filters || {}) });
    if (event.matches) updateIndex();
  });

  updateIndex({ announce: false });
  };

  const start = () => document.querySelectorAll('[data-fw26-men]').forEach(mount);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
  document.addEventListener('shopify:section:load', start);
})();
